module.exports = __webpack_public_path__ + "static/media/image1.9c672344.jpg";